"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
const react_1 = __importDefault(require("react"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const grid_styles_1 = require("./grid-styles");
function Grid({ children, gap = 10, columns, }) {
    const classes = grid_styles_1.useStyles();
    return (react_1.default.createElement(Box_1.default, { className: classes.root, gridTemplateColumns: `repeat(${columns}, 1fr)`, gridGap: gap }, children));
}
exports.Grid = Grid;
//# sourceMappingURL=grid.js.map